import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'dialog-working',
    templateUrl: './dialog-working.component.html',
    styleUrls: ['./dialog-working.component.scss'],
    standalone: false
})
export class DialogWorkingComponent implements OnInit {
  constructor(
    public dialog: MatDialog,
  ) { }

  ngOnInit() {
  }

  onClose() {
    this.dialog.closeAll();
  }


}
